import { render, staticRenderFns } from "./ResolveChildDialog.vue?vue&type=template&id=25f955d2&scoped=true"
import script from "./ResolveChildDialog.vue?vue&type=script&lang=ts"
export * from "./ResolveChildDialog.vue?vue&type=script&lang=ts"
import style0 from "./ResolveChildDialog.vue?vue&type=style&index=0&id=25f955d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25f955d2",
  null
  
)

export default component.exports